import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=04261af4"
import script from "./MFooter.vue?vue&type=script&lang=js"
export * from "./MFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports